import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackEvent } from '../utils/analytics';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Отслеживаем просмотр страницы при изменении маршрута
    trackPageView(location.pathname + location.search);
  }, [location]);

  return {
    trackEvent: (category: string, action: string, label?: string, value?: number) => {
      trackEvent(category, action, label, value);
    }
  };
}; 